import Footer from '@components/Footer'

const MenuLayout = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            <div className='h-dvh flex flex-col'>
                {children}
                <Footer />
            </div>
        </>
    )
}

export default MenuLayout